var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "95D73A48-9D31-4C7C-84A6-D090C6F654ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-Team-Edit-Specialties",
    transform: "translate(-1391.000000, -122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-84",
    transform: "translate(492.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(899.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#8894A6",
    cx: 19,
    cy: 19,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(13.000000, 13.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.333333333,
    y1: 0.352941176,
    x2: 11.6666667,
    y2: 11.6470588,
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.333333333,
    y1: 0.352941176,
    x2: 11.6666667,
    y2: 11.6470588,
    id: "Line-3",
    transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/close-modal-icon.4e79c834ff5e43050571f1ec0830d81e.svg";
export { ForwardRef as ReactComponent };